
const AboutDetail = () => {
  return (
    <div className="rounded-md bg-white p-4">
    <h1 className="text-2xl font-bold mb-4 text-darkBlue">About Department</h1>
    <p>
      The Acıbadem University School of Medicine was established in 2007 and
      accepted its first students into the academic year starting in 2009
      following a two year period where the curriculum was devised. The
      school was initially established on a modest campus located in
      Maltepe. In 2013, it moved to the purpose-built Kerem Aydınlar Campus,
      one of the most developed science campuses in Turkey. The campus
      features a Center of Advanced Simulation and Education (CASE) while
      practical applications take place at Acıbadem Atakent and Acıbadem
      Maslak Education and Research Hospitals and the Education Research
      Regions whose affiliation with the Council of Higher Education (YÖK)
      is complete. Education at the School of Medicine is in English and our
      education program features three phases. Phase I is integrated Basic
      and Clinical Sciences, Phase II is Clinical Clerkships and Phase III
      is Internships.Our education is based on an integrated curriculum. In
      the program for Phase I systems in organisms ranging from the simplest
      units such as cells to more complex systems including pathologies are
      taught as a whole. Phase I also includes Clinical Medicine and
      Professional Skills (CMPS) which is a program designed to be an
      initial introduction to medical professionalism providing students
      with relevant knowledge and skills. This program includes applied
      communication courses designed to help students with honing their
      skills prior to meeting patients during the Clinical Clerkship phase.
      Additionally, Phase I is enriched with practical applications at
      Family and Society Health Centers. This phase involves training
      settings which support the development of intellectual skills and
      human values. During the 1-year Clinical Clerkships of Phase II,
      students continue to develop their existing clinical knowledge and
      skills by caring for inpatients and outpatients in a hospital setting.
      During the 1-year Internship of Phase III students undertake the
      responsibility of patient care in a hospital or primary care setting
      under the supervision of teaching staff where they are able to apply
      their knowledge and skill in full. Students develop their clinical
      skills through participation in programs at the Center of Advanced
      Simulation and Education (CASE) for six terms. Our faculty boasts a
      strong academic staff. Our mission is to ensure young people from
      Turkey and around the world who choose to study medicine at our
      establishment are nurtured to become universal physicians who are
      sensitive to the needs of the society they live in and the world, who
      fully comprehend the importance of knowledge and academic thought, who
      are curious and inquisitive, with an excellent command of technology.
      We strive to ensure our students understand that patients are our
      priority, who are humanitarian, who have excellent communication
      skills and who respect their fellow medical professional co-workers
      and who have embraced the importance of ethical values and team work.
      Acıbadem University School of Medicine invests in science and
      encourages its students to carry out research and publish research
      papers. We emphasize the importance of training in society in addition
      to internships and we aim to train universal physicians who strive for
      great achievements in all fields of medicine on a national and
      international scale. We are proud of the superior levels of competence
      and awareness displayed by our graduates in specialist programs in the
      field of primary healthcare. We continue to stride confidently towards
      our goal of training the best physicians in Turkey.
    </p>
  </div>
  )
}

export default AboutDetail
